<template>
    <section class="not-found">
        <span>404</span>
        <h1>Page not found</h1>
    </section>
</template>

<script>
export default {
  name: 'NotFoundComponent'
}
</script>

<style lang="scss" scoped>
    .not-found {
        max-width: 560px;
        margin: 40px auto 0;
        padding: 34px;
        border: 1px solid rgba(111, 168, 205, 0.22);
        border-radius: 6px;
        background: rgba(5, 9, 11, 0.72);
        color: #edf4f8;
        text-align: center;
        box-shadow: 0 18px 36px rgba(0, 0, 0, 0.28);

        span {
            display: block;
            color: #77d0ff;
            font-size: 13px;
            font-weight: 800;
        }

        h1 {
            margin-top: 6px;
            font-size: 30px;
        }
    }
</style>
